<template>
  <div>
    <Modal
      title="Q&A"
      v-model="QAModal"
      draggable
      sticky
      scrollable
      :mask="false"
      width="660"
      :footer-hide="true"
      @on-cancel="cancel"
    >
      <div class="demo-split mainCard">
        <Split v-model="split1" min="160" max="280">
          <div slot="left" class="splitLeft">
            <div class="search">
              <Input
                v-model="searchItem.cname"
                prefix="ios-search"
                @on-focus="focusData"
                @on-clear="showSearchUser = false"
                @on-change="searchData"
                placeholder="请输入姓名"
              >
                <Icon
                  v-show="showSearchUser"
                  type="ios-close-circle"
                  @click="(searchItem.cname = ''), (showSearchUser = false)"
                  slot="suffix"
                />
              </Input>
            </div>
            <div class="userList" v-if="!showSearchUser">
              <div
                class="userItem"
                v-for="(item, index) in userList"
                :key="index"
                @click="userItemClick(item, index)"
                :style="{
                  background: selectIndex == index ? '#eeeeee' : '#ffffff'
                }"
              >
                <div>
                  <Badge :count="Number(item.beReadNum)">
                    <Avatar
                      v-if="item.portrait"
                      :src="'data:image/jpeg;base64,' + item.portrait || ''"
                      size="large"
                    />
                    <Avatar
                      v-else
                      style="background-color: #006B37"
                      icon="ios-person"
                      size="large"
                    />
                  </Badge>
                </div>
                <div class="talkUser">
                  <div class="user">
                    <span class="name">{{ item.userName }}</span>
                    <p>{{ item.userEName }}</p>
                    <!-- <div class="date">{{item.date}}</div> -->
                  </div>
                  <!-- <span class="talkText">{{item.talk}}</span> -->
                </div>
              </div>
            </div>
            <div class="userList" v-if="showSearchUser">
              <div
                class="userItem"
                v-for="(item, index) in searchUserList"
                :key="index"
                @click="userItemSelect(item, index)"
              >
                <div>
                  <Avatar
                    v-if="item.portrait"
                    :src="'data:image/jpeg;base64,' + item.portrait || ''"
                    size="large"
                  />
                  <Avatar
                    v-else
                    style="background-color: #006B37"
                    icon="ios-person"
                    size="large"
                  />
                </div>
                <div class="talkUser">
                  <div class="user">
                    <span class="name">{{ item.userName }}</span>
                    <p>{{ item.userEName }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div slot="right" class="splitRight">
            <div class="userTit">{{ toUserItem.userName }}</div>
            <div class="qaList">
              <div>
                <div
                  class="qaItem"
                  v-for="(item, index) in dataList"
                  :key="index"
                >
                  <div
                    class="questionContent"
                    v-if="item.sendUser == userInfo.serialnumber"
                  >
                    <div class="questionContentRight">
                      <div class="word">{{ item.qaWord }}</div>
                      <div class="form-inline">
                        <span>{{ item.qaFileName }}</span>
                        <Button
                          icon="ios-download-outline"
                          type="primary"
                          size="small"
                          v-if="item.qaFileName"
                          @click="downloadFile(item.qaFileId)"
                          style="margin-left: 20px;margin-top:10px"
                          >附件下载</Button
                        >
                      </div>
                    </div>
                    <!-- <Avatar v-if="toUserItem.portrait" :src="'data:image/jpeg;base64,' + item.portrait || ''"  size="large"/> -->
                    <Avatar style="background-color: #006B37" size="large">{{
                      item.sendUser
                    }}</Avatar>
                  </div>
                  <div
                    v-if="item.receiveUser == userInfo.serialnumber"
                    class="replyContent"
                  >
                    <Avatar
                      v-if="toUserItem.portrait"
                      :src="
                        'data:image/jpeg;base64,' + toUserItem.portrait || ''
                      "
                      size="large"
                    />
                    <Avatar
                      v-else
                      style="background-color: #006B37"
                      size="large"
                      >{{ item.sendUser }}</Avatar
                    >
                    <div class="questionContentLeft">
                      <div class="word">{{ item.qaWord }}</div>
                      <div class="form-inline">
                        <span>{{ item.qaFileName }}</span>
                        <Button
                          icon="ios-download-outline"
                          type="primary"
                          size="small"
                          v-if="item.qaFileName"
                          @click="downloadFile(item.qaFileId)"
                          style="margin-left: 20px;margin-top:10px"
                          >附件下载</Button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="qaForm">
              <Input
                type="textarea"
                v-model="formData.desc"
                :autosize="{ maxRows: 4, minRows: 4 }"
              />
              <div class="form-inline" style="margin-top:10px;display:flex">
                <Upload
                  :action="action"
                  ref="my-upload"
                  :on-success="uploadSuccess"
                  :show-upload-list="false"
                >
                  <Button icon="ios-cloud-upload-outline">上传附件</Button>
                </Upload>
                <span>{{ filename }}</span>
              </div>
            </div>
            <div class="demo-drawer-footer">
              <Poptip :disabled="savePopShow" :content="savecontent">
                <Button type="primary" @click="save"
                  ><!-- 提交 -->{{ $t("Submit") }}</Button
                >
              </Poptip>
            </div>
          </div>
        </Split>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from "axios";
var W3CWebSocket = require("websocket").w3cwebsocket;
export default {
  data() {
    return {
      split1: 0.2,
      searchItem: {},
      userList: [],
      savePopShow: true,
      selectIndex: 0,
      toUserItem: {},
      dataList: [],
      action: "/api/resource/upload",
      formData: {
        desc: "",
        qaFile: ""
      },
      filename: "",
      showSearchUser: false,
      savecontent: "不能发送空信息",
      questionList: [],
      ws: null,
      searchUserList: [],
      userInfo: {},
      allUser: [],
      talkUser: [],
      selectUserItem: {},
      QAModal: false
    };
  },
  mounted() {
    this.dataList = this.questionList;
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    // this.getUserList()
    this.init();
    this.setInit();
  },
  methods: {
    getUserList() {
      this.userList = [];
      let obj = {};
      axios.post("/mQaRecordInfo/selectQaRecordList", obj).then(res => {
        if (res) {
          this.userList = res;
          this.active =
            this.userList.length > 0 ? this.userList[0].serialnumber : "";
          this.init();
        }
      });
    },
    searchData() {
      let obj = {
        instanceId: "",
        qaId: this.qaId,
        cName: this.searchItem.cname,
        pageNo: 1,
        pageSize: 100
      };
      axios.post("/QaForEmp/selectQaForEmp", obj).then(res => {
        if (res) {
          let talkUser = res.talkUser.data.data;
          let allUser = res.allUser.data.data;
          let list = allUser.filter(v =>
            talkUser.every(val => val.serialnumber != v.serialnumber)
          );
          this.searchUserList = list;
        }
      });
    },
    init() {
      const env = process.env.NODE_ENV;
      const wsUrl =
        env === "development"
          ? process.env.ws + `api/socket/${this.userInfo.serialnumber}`
          : process.env.ws + `api/socket/${this.userInfo.serialnumber}`;
      this.ws = new W3CWebSocket(wsUrl);
      //监听是否连接成功
      this.ws.onopen = () => {
        console.log("ws连接状态：" + this.ws.readyState);
        if (this.ws.readyState == 1) {
          //连接成功则发送一个数据
          this.ws.send("");
        }
      };
      this.ws.onmessage = this.websocketonmessage;
      //监听并处理error事件
      this.ws.onerror = function(error) {
        console.log(error);
      };
    },
    websocketonmessage(data) {
      console.log(this.selectUserItem);
      let list = JSON.parse(data.data);
      this.userList = list.data.data;
      let obj = {};
      obj = this.userList[0];
      this.userList.forEach(el => {
        // obj=this.userList[0]
        if (el.userSerialnumber == this.selectUserItem.userSerialnumber) {
          obj = el;
        }
      });
      this.userItemClick(obj, this.selectIndex);
    },
    userItemClick(item, index) {
      this.selectIndex = index;
      this.toUserItem = JSON.parse(JSON.stringify(item));
      this.dataList = item.mQaRecordsList;
      this.clearData(item.qaId);
      item.beReadNum = null;
      // this.selectUserItem=JSON.parse(JSON.stringify(this.toUserItem))
    },
    userItemSelect(item, index) {
      item.userName = item.cName;
      item.receiveUser = item.serialnumber;
      this.userList.unshift(item);
      this.showSearchUser = false;
      this.userItemClick(item, 0);
      this.searchItem.cname = "";
      this.searchUserList = [];
    },
    save() {
      if (this.formData.desc == "") {
        this.savePopShow = false;
        return;
      } else {
        this.savePopShow = true;
      }
      let obj = {
        receiveUser: this.toUserItem.userSerialnumber,
        qaWord: this.formData.desc,
        qaFileId: this.formData.qaFile,
        qaId: this.toUserItem.qaId
      };
      this.selectUserItem = JSON.parse(JSON.stringify(this.toUserItem));
      axios.post("/mQaRecordInfo/submitQaRecordList", obj).then(res => {
        if (res) {
          this.ws.send(
            JSON.stringify({
              qaId: res,
              replyUserId: this.userInfo.serialnumber,
              receiveUser: this.toUserItem.userSerialnumber
            })
          );
          this.formData.desc = "";
          this.filename = "";
          this.formData.qaFile = "";
        }
      });
    },
    focusData() {
      this.showSearchUser = false;
      this.$nextTick(() => {
        this.showSearchUser = true;
      });
    },
    uploadSuccess(val, file) {
      this.filename = file.name;
      this.formData.qaFile = val.data;
    },
    downloadFile(attach) {
      axios({
        url: "/resource/download",
        method: "post",
        data: { resourceId: attach },
        responseType: "blob"
      }).then(res => {
        var A = this.$store.getters.pageData.axiosHeader[
          "content-disposition"
        ].split("fileName=")[1];
        var FileSaver = require("file-saver");
        FileSaver.saveAs(new Blob([res]), decodeURIComponent(A));
      });
    },
    clearData(val) {
      axios
        .post("/mQaRecordInfo/updateBeReadStatus", { qaId: val })
        .then(res => {
          if (res) {
            this.$store.state.noticeBeReadId = val;
          }
        });
    },
    cancel() {
      this.QAModal = false;
    },
    getQuestionList() {
      let obj = {
        reply_user_id: this.userInfo.serialnumber,
        qaId: this.qaId,
        beReply: "",
        pageNo: 1, //页码
        pageSize: 10 //每页数据条数
      };
      axios.post("/mQaRecordInfo/selectQaRecordList", obj).then(res => {
        if (res) {
          if (this.userList.length > 0) {
            this.questionList = res;
          } else {
            this.questionList = [];
          }
          this.userItemClick(this.questionList[0], 0);
        }
      });
    },
    setInit() {
      setTimeout(() => {
        if (this.ws.readyState != 1) {
          this.init();
        }
      }, 100000);
    }
  },
  beforeDestory() {
    if (this.ws) {
      this.ws.onclose = () => {
        //监听整个过程中websocket的状态
        console.log("断开连接" + this.ws.readyState);
      };
    }
  }
};
</script>

<style lang="scss" scoped>
>>> .ivu-drawer-body {
  background: #ffffff !important;
}
>>> .ivu-avatar-image {
  display: flex;
  align-items: center;
  justify-content: center;
}
>>> .ivu-avatar > img {
  width: 20px;
  height: 20px;
}
.demo-split {
  height: calc(100vh - 450px);
  border: 1px solid #dcdee2;
}
.mainCard {
  width: 100%;
  height: calc(100vh - 450px);
  box-sizing: border-box;
  .splitMain {
    height: calc(100vh - 450px);
  }
  .splitLeft {
    padding: 20px 0;
    .search {
      padding: 0 15px;
    }
    .userList {
      margin-top: 10px;
      height: calc(100vh - 520px);
      overflow-y: auto;
      .userItem {
        display: flex;
        padding: 10px 15px 10px 15px;
        align-items: center;
        justify-content: flex-start;

        cursor: pointer;
        .talkUser {
          margin-left: 10px;
          width: calc(100% - 50px);
          .user {
            // display: flex;
            // justify-content: space-between;
            .name {
              color: #000000;
            }
            .date {
              color: #5a5a5a;
              font-size: 14px;
            }
          }
          .talkText {
            color: #5a5a5a;
            font-size: 14px;
          }
        }
      }
    }
  }
  .splitRight {
    padding: 20px 0;
  }
}
>>> .ivu-card-body {
  padding: 0 !important;
}
.userItem:hover {
  background: antiquewhite;
}
.userTit {
  padding: 0 20px;
}
.qaList {
  background: #f7f7f7;
  padding: 0 20px;
  height: calc(100vh - 650px);
  overflow-y: auto;
  margin-top: 10px;
}
.userItem {
  display: flex;
}
.qaItem {
  padding: 10px;
  .questionContent {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    .questionContentRight {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      max-width: calc(100% - 20px - 32px);
      margin-right: 10px;
    }
    .word {
      // border: 1px solid #dcdee2;
      background: #c1e4d3;
      padding: 10px 12px;
      border-radius: 10px 0 10px 10px;
      min-height: 32px;
      line-height: 20px;
      box-sizing: border-box;
      // max-width: calc(100% - 10px);
    }
  }
  .form-inline {
    display: flex;
    align-items: flex-end;
  }
  .replyContent {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 10px;
    .questionContentLeft {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      max-width: calc(100% - 20px - 32px);
      width: 100%;
    }
    .word {
      // border: 1px solid #dcdee2;
      background: #e7e7e7;
      padding: 10px 12px;
      border-radius: 0 10px 10px 10px;
      min-height: 32px;
      line-height: 20px;
      margin-left: 10px;
      box-sizing: border-box;
      max-width: calc(100% - 20px - 32px);
    }
  }
}
.qaForm {
  padding: 0 5px 0 10px;
}
.demo-drawer-footer {
  display: flex;
  justify-content: flex-end;
  position: absolute;
  right: 10px;
  bottom: 10px;
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #006b37;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #ededed;
}
.userItemActive {
  background: #dcdee2;
}
</style>



// WEBPACK FOOTER //
// src/components/process/Apply/components/QAComponent.vue